import React from "react";
import { Link } from "react-router-dom";
import { art, CONTACT_EMAIL } from "./config";

const QA = [
  {
    q: "What ages is Leo for?",
    a: "Children in Years 1 to 6 — roughly ages 5 to 11. Tell me their year group when you set up and I'll pitch everything to the National Curriculum for that year.",
  },
  {
    q: "Does my child need to read or type?",
    a: "No. It's all talking and listening, so children who aren't confident readers yet get on just fine. Pictures appear on screen when they help, but nothing has to be read to play.",
  },
  {
    q: "Is it actually teaching, or just chatting?",
    a: "Both, on purpose. Every chat follows a maths thread for their year, I check their answers, and I come back to topics until they're secure. It just never feels like a lesson, because your child is the one doing the explaining.",
  },
  {
    q: "How do you keep my child safe?",
    a: "A grown-up unlocks every session with Face ID or a passcode. Nobody else can contact your child through Leo, there are no ads, and if a child says something worrying I stop the maths, respond carefully and point them to a trusted adult and Childline. You can see everything I remember and delete it.",
  },
  {
    q: "Can brothers and sisters use it?",
    a: "Yes. Add each child to your account and they each get their own Leo — their own progress, their own memories. One Leo Plus subscription covers them all.",
  },
  {
    q: "What phones does it work on?",
    a: "Leo is on iPhone today, from the App Store. Android is on the list — drop us a line if you'd like to hear when it's ready.",
  },
  {
    q: "How much does it cost?",
    a: "You can try Leo free. After that, Leo Plus is £9.99 a month or £89 a year, with a 7-day free trial, and you can cancel any time in your iPhone Settings.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="section" style={{ paddingTop: 0 }} data-testid="faq-section">
      <div className="wrap faq-grid">
        <div>
          <span className="eyebrow rv">Questions</span>
          <h2 className="h2 rv" style={{ "--d": "80ms" }}>
            Good <span className="said">questions.</span>
          </h2>
          <p className="lede rv" style={{ marginTop: 20, "--d": "160ms" }}>
            Anything else? Email{" "}
            <a href={`mailto:${CONTACT_EMAIL}`} className="underline underline-offset-4 decoration-[var(--leo-orange)]">
              {CONTACT_EMAIL}
            </a>{" "}
            or <Link to="/contact" className="underline underline-offset-4 decoration-[var(--leo-orange)]">get in touch</Link>. A real person replies.
          </p>
          <img className="faq-leo rv" src={art("leo-sitting-600.png")} alt="" loading="lazy" />
        </div>
        <div className="faq rv" style={{ "--d": "120ms" }}>
          {QA.map(({ q, a }) => (
            <details key={q}>
              <summary>
                {q}
                <i aria-hidden>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                    <path d="M12 5v14M5 12h14" />
                  </svg>
                </i>
              </summary>
              <p>{a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
